(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5649],{

/***/ 584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17674);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ilenia__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53333);
/* harmony import */ var _components_SingleResourceView__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97169);
/* harmony import */ var _components_ResourceSearch__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69498);
/* harmony import */ var _layouts_BaseLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41462);
/* harmony import */ var _main_contexts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86816);
/* harmony import */ var _components_ResourcePillarNavigation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95834);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);











var GuideReport = function GuideReport(_ref) {
  var pillar = _ref.router.query.pillar,
      guideReport = _ref.guideReport,
      relatedGuidesReports = _ref.relatedGuidesReports;

  var _useTranslations = (0,ilenia__WEBPACK_IMPORTED_MODULE_7__/* .useTranslations */ .T)(),
      _useTranslations2 = (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_useTranslations, 1),
      translations = _useTranslations2[0];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_layouts_BaseLayout__WEBPACK_IMPORTED_MODULE_3__/* .BaseLayout */ .I, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_main_contexts__WEBPACK_IMPORTED_MODULE_4__/* .ResourceProvider */ .bQ, {
      value: "guides-reports",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_ResourcePillarNavigation__WEBPACK_IMPORTED_MODULE_5__/* .PillarNavigation */ .Z, {
        breadcrumbs: translations['guides-reports/page/title'],
        searchBar: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_ResourceSearch__WEBPACK_IMPORTED_MODULE_2__/* .Search */ .o, {
          contentfulResource: "guideReport",
          placeholder: translations['guides-reports/search']
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_SingleResourceView__WEBPACK_IMPORTED_MODULE_1__/* .SingleResourceArticle */ .NV, {
        pillar: pillar,
        resource: guideReport
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_SingleResourceView__WEBPACK_IMPORTED_MODULE_1__/* .RelatedResources */ .Ks, {
        relatedResources: relatedGuidesReports
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_SingleResourceView__WEBPACK_IMPORTED_MODULE_1__/* .BelowTheFoldContent */ .Dz, {
        resource: guideReport
      })]
    })
  });
};

var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = ((0,next_router__WEBPACK_IMPORTED_MODULE_0__.withRouter)(GuideReport));

/***/ }),

/***/ 96552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Arrow; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32125);

var Arrow = styled_components__WEBPACK_IMPORTED_MODULE_0__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "Arrows__Arrow",
  componentId: "sc-1gwjvbv-0"
})(["", ""], function (_ref) {
  var direction = _ref.direction,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'rgb(0,0,50)' : _ref$color;
  return "\n    width: 9px;\n    height: 9px;\n    display: inline-block;\n    border-top: 2px solid ".concat(color, ";\n    border-right: 2px solid ").concat(color, ";\n    transform: rotate(").concat(direction === 'left' ? '-135deg' : '45deg', ");\n  ");
});

/***/ }),

/***/ 70405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hn": function() { return /* binding */ DropDownContainer; },
/* harmony export */   "Kv": function() { return /* binding */ DropDownSearch; },
/* harmony export */   "NB": function() { return /* binding */ DropDownList; },
/* harmony export */   "RC": function() { return /* binding */ useDropDownLogic; },
/* harmony export */   "bK": function() { return /* binding */ DropDownItem; },
/* harmony export */   "uR": function() { return /* binding */ BasicDropDown; }
/* harmony export */ });
/* unused harmony exports DropDownSelectedItem, DropDownArrowWrapper, FocusedDropDownSearch */
/* harmony import */ var _home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17674);
/* harmony import */ var _home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32125);
/* harmony import */ var ilenia__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53333);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61222);
/* harmony import */ var _utilities_keypress__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11893);
/* harmony import */ var _Icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var DropDownContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "DropDown__DropDownContainer",
  componentId: "sc-14dp86x-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme,
      overlay = _ref.overlay,
      opened = _ref.opened,
      maxWidth = _ref.maxWidth;
  return "\n    outline: none;\n    width: 100%;\n    max-width: 544px;\n    text-align: left;\n    position: relative;\n    border-radius: 2px;\n    color: ".concat(theme.colors.greyRegular, ";\n    transition: border 0.5s;\n    background-color: ").concat(theme.colors.white, ";\n    border: 1px solid ").concat(opened ? theme.colors.blueSaturated : theme.colors.greyRegular, ";\n\n    ").concat(maxWidth && "width: calc(100% - ".concat(theme.heights.spacingTablet, "px);"), ";\n\n    ").concat(overlay && "\n      position: absolute;\n      border: 0;\n      z-index: 100;\n      padding: 0;\n      width: 50%;\n      margin: 1px;\n      max-width: 78px;\n\n      &:after {\n        content: \"\";\n        margin: auto;\n        width: 1px;\n        height: 50%;\n        position: absolute;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        border-right: 1px solid;\n      }\n    ", ";\n  ");
});
var DropDownList = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "DropDown__DropDownList",
  componentId: "sc-14dp86x-1"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme,
      opened = _ref2.opened,
      overlay = _ref2.overlay,
      expanded = _ref2.expanded;
  return "\n    margin: -1px -1px 0;\n    padding: 0;\n    border-top: 0;\n    overflow-y: auto;\n    position: absolute;\n    list-style-type: none;\n    width: calc(100% + 2px);\n    background-color: ".concat(theme.colors.white, ";\n    z-index: ").concat(theme.zIndexes.dropdowns, ";\n    border: 1px solid ").concat(theme.colors.blueSaturated, ";\n\n    ").concat(opened && "border-top: 0", ";\n    ").concat(overlay && "border-color: ".concat(theme.colors.greyLight), ";\n    ", "max-height: ".concat(expanded ? '800' : '300', "px;"), ";\n  ");
});
var DropDownSelectedItem = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "DropDown__DropDownSelectedItem",
  componentId: "sc-14dp86x-2"
})(["", ""], function (_ref3) {
  var theme = _ref3.theme,
      error = _ref3.error,
      value = _ref3.value;
  return "\n    display: inline-block;\n    padding: 15px 12px 15px 18px;\n    color: ".concat(error ? 'red' : value ? theme.colors.greyRegular : theme.colors.greyRegular, ";\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n    width: 100%;\n    cursor: pointer;\n    text-align: left;\n    background: none;\n    border: none;\n\n    &:focus {\n      outline-radius: 2px;\n      outline: 1px solid ").concat(theme.colors.blueSaturated, ";\n    }\n  ");
});
var DropDownItem = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "DropDown__DropDownItem",
  componentId: "sc-14dp86x-3"
})(["", ""], function (_ref4) {
  var theme = _ref4.theme,
      empty = _ref4.empty,
      selected = _ref4.selected;
  return "\n    width: 100%;\n    padding: 15px;\n    cursor: pointer;\n    background: none;\n    border: none;\n    text-align: left;\n\n    ".concat(empty && "\n      cursor: default;\n      text-align: center;\n      font-style: italic;\n    ", "\n\n    ").concat(selected ? "background-color: ".concat(theme.colors.greyLighter, ";") : '', ";\n\n    &:focus {\n      ").concat(!empty && "background-color: ".concat(theme.colors.greyLighter, ";"), "\n      outline: none;\n    }\n  ");
});
var DropDownArrowWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].span.withConfig */ .ZP.span.withConfig({
  displayName: "DropDown__DropDownArrowWrapper",
  componentId: "sc-14dp86x-4"
})(["", ""], function (_ref5) {
  var theme = _ref5.theme,
      opened = _ref5.opened;
  return "\n    right: 0;\n    padding: 16px 16px 16px 0;\n    position: absolute;\n    color: ".concat(theme.colors.greyDarkest, ";\n\n    svg {\n      transform: rotate(0deg);\n      transition: transform 0.3s ease-in-out;\n\n      ").concat(opened && "\n        transform: rotate(-180deg);\n      ", "\n    }\n  ");
});
var DropDownSearch = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].input.withConfig */ .ZP.input.withConfig({
  displayName: "DropDown__DropDownSearch",
  componentId: "sc-14dp86x-5"
})(["width:100%;border:none;background:none;padding:15px 18px;display:inline-block;transform:translateZ(0);:focus{outline:none;}&::placeholder{color:", ";}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.greyDark;
});
var FocusedDropDownSearch = function FocusedDropDownSearch(props) {
  var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    return ref.current.focus();
  }, [ref]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(DropDownSearch, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref
  }));
};
var useDropDownLogic = function useDropDownLogic(_ref7) {
  var _ref7$menuItems = _ref7.menuItems,
      menuItems = _ref7$menuItems === void 0 ? [] : _ref7$menuItems,
      initialValue = _ref7.initialValue;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      opened = _useState[0],
      setOpened = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''),
      searchTerm = _useState2[0],
      setSearchTerm = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null),
      selectedItem = _useState3[0],
      setSelectedItem = _useState3[1];

  var dropDownRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (typeof initialValue !== 'undefined') {
      setSelectedItem(menuItems.find(function (_ref8) {
        var value = _ref8.value;
        return value === initialValue;
      }));
    }
  }, []);
  (0,_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useClickOutside */ .O8)(dropDownRef, function () {
    setOpened(false);
    setSearchTerm('');
  });
  return {
    dropDownRef: dropDownRef,
    opened: opened,
    setOpened: setOpened,
    searchTerm: searchTerm,
    selectedItem: selectedItem,
    setSearchTerm: setSearchTerm,
    setSelectedItem: setSelectedItem,
    filteredMenuItems: searchTerm ? menuItems.filter(function (_ref9) {
      var label = _ref9.label;
      return label.toLowerCase().startsWith(searchTerm.toLowerCase());
    }) : menuItems
  };
};
var BasicDropDown = function BasicDropDown(_ref10) {
  var error = _ref10.error,
      _ref10$onChange = _ref10.onChange,
      onChange = _ref10$onChange === void 0 ? function () {} : _ref10$onChange,
      menuItems = _ref10.menuItems,
      placeholder = _ref10.placeholder,
      initialValue = _ref10.initialValue,
      disableSearch = _ref10.disableSearch,
      overlay = _ref10.overlay,
      _ref10$className = _ref10.className,
      className = _ref10$className === void 0 ? '' : _ref10$className,
      reset = _ref10.reset;

  var _useTranslations = (0,ilenia__WEBPACK_IMPORTED_MODULE_7__/* .useTranslations */ .T)(),
      _useTranslations2 = (0,_home_travis_build_trustpilot_businesssite_main_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_useTranslations, 1),
      translations = _useTranslations2[0];

  var _useDropDownLogic = useDropDownLogic({
    menuItems: menuItems,
    initialValue: initialValue
  }),
      dropDownRef = _useDropDownLogic.dropDownRef,
      opened = _useDropDownLogic.opened,
      setOpened = _useDropDownLogic.setOpened,
      selectedItem = _useDropDownLogic.selectedItem,
      setSearchTerm = _useDropDownLogic.setSearchTerm,
      setSelectedItem = _useDropDownLogic.setSelectedItem,
      filteredMenuItems = _useDropDownLogic.filteredMenuItems;

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(reset),
      isReset = _useState4[0],
      setReset = _useState4[1];

  (0,_utilities_keypress__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)('Escape', function () {
    return opened && setOpened(false);
  });
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (isReset !== reset) {
      setSelectedItem(undefined);
      setReset(reset);
    }
  }, [reset]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(DropDownContainer, {
    ref: dropDownRef,
    opened: opened,
    className: className,
    overlay: overlay,
    onClick: function onClick() {
      return setOpened(!opened);
    },
    children: [opened && !disableSearch ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(FocusedDropDownSearch, {
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      onChange: function onChange(e) {
        return setSearchTerm(e.target.value);
      },
      placeholder: !overlay ? translations['basic/search'] : ''
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(DropDownSelectedItem, {
      error: error,
      value: selectedItem ? selectedItem.value : null,
      children: error ? error : selectedItem ? selectedItem.label : placeholder
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(DropDownArrowWrapper, {
      opened: opened,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_Icons__WEBPACK_IMPORTED_MODULE_4__/* .DropDownArrowIcon */ .PV, {})
    }), opened && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(DropDownList, {
      opened: opened,
      overlay: overlay,
      children: filteredMenuItems.length > 0 ? filteredMenuItems.map(function (item) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("li", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(DropDownItem, {
            onClick: function onClick() {
              setSelectedItem(item);
              setSearchTerm('');
              onChange(item);
              setOpened(false);
            },
            children: item.label
          })
        }, "".concat(item.label, "-").concat(item.value));
      }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("li", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(DropDownItem, {
          empty: true,
          children: "No result found"
        })
      })
    })]
  });
};

/***/ }),

/***/ 98003:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides-reports/[pillar]/[slug]",
      function () {
        return __webpack_require__(584);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6048,7262,53,47,9787,1118,6814,9085,9669,9230,7147,2691,2580,4094,1880,5269,6702,9774,2888,179], function() { return __webpack_exec__(98003); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);